export const repeatTypes = [
  {
    label: "不重复",
    value: "0"
  },
  {
    label: "一次",
    value: "1"
  },
  {
    label: "两次",
    value: "2"
  },
  {
    label: "三次",
    value: "3"
  },
  {
    label: "无限重复",
    value: "infinite"
  }
]
export const showTypes = [
  {
    label: "显示",
    value: "In"
  },
  {
    label: "隐藏",
    value: "Out"
  },
  {
    label: "显隐切换",
    value: "exchange"
  }
]
export const actionTypes = [
  {
    label: "淡",
    value: "fade"
  },
  {
    label: "跳",
    value: "bounce"
  },
  {
    label: "旋转",
    value: "rotate"
  },
  {
    label: "缩放",
    value: "zoom"
  },
  {
    label: "滑",
    value: "slide"
  }
]
export const actionDesTypes = [
  {
    label: "无",
    value: ""
  },
  {
    label: "上",
    value: "Down"
  },
  {
    label: "下",
    value: "Up"
  },
  {
    label: "左",
    value: "Left"
  },
  {
    label: "右",
    value: "Right"
  }
]
